import React, { Component } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { isEmpty, get } from 'lodash';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import {
  INBOUND_DATE,
  OUTBOUND_DATE,
  AUTOCOMPLETE_TYPE,
  SUBMIT_TEXT,
  RADIOBUTTONLIST_TEXT,
  DATE_TEXT,
  RETURN_LABEL_TEXT,
  FROM_LOCATION_TEXT,
  TO_LOCATION_TEXT,
  FORM_TYPE_TO_CHECK_FLIGHT,
} from './Constants';
import Form from '../../../../components/organism/form';
import SelectMUI from '../../../../components/atoms/Forms/Select';
import RadioMUI from '../../../../components/atoms/Forms/Radio';
import ButtonMUI from '../../../../components/atoms/Button';
import Calender from '../../../../components/atoms/Forms/Calendar';
import AutoCompleteMUI from '../../../../components/atoms/AutoComplete';
import { pushAnaylyticsData } from '../../../../../../src/utils/analytics';
import { analyticsData } from '../../../../../../src/constants/Analytics/analytics-data';
import fetchService from '../../../../../services/FetchService';
import { replaceKeysLabelText } from '../../../../../utils/utility';
import { createDynamicLabels } from '../../../../../utils/analytics';
import { LANGUAGE_CODE } from '../../../../../constants';
import { getDictionaryText } from '../../../../utils/getDictionaryText';

class FlightsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: [],
      // autoCompleteListItems: [],
      autoCompleteListItems: [{ name: '' }],
    };
    /**
     * Mapping of individual atoms within molecule
     */
    this.mapper = {
      Dropdown: SelectMUI,
      RadioButtonList: RadioMUI,
      DateRange: Calender,
      Date: Calender,
      Submit: ButtonMUI,
      AutoComplete: AutoCompleteMUI,
    };
    this.flightsPayload = {};
    this.radioListValue = '';
    this.rules = [];
    this.redirectSitecoreURL = '';
    this.language = get(props, 'sitecoreContext.language', '');
  }

  componentDidMount() {
    try {
      let { formData } = this.props;
      formData.map(data => {
        if (get(data, 'fields.fieldType.value') !== AUTOCOMPLETE_TYPE) {
          const { defaultValue } = data.fields;
          data.fields.selectedValue = {
            value: get(defaultValue, 'fields.key.value'),
          };
        } else {
          data.fields.selectedValue = { value: '' };
        }
        if (get(data, 'fields.fieldType.value') === AUTOCOMPLETE_TYPE) {
          data.fields.selectedValue = { value: '' };
        }
        if (get(data, 'fields.fieldType.value') === DATE_TEXT) {
          data.fields.startDate = { value: '' };
          data.fields.startDateName = { value: INBOUND_DATE };
          data.fields.endDate = { value: '' };
          data.fields.endDateName = { value: OUTBOUND_DATE };
        }
        if (
          get(data, 'fields.fieldType.value') !== SUBMIT_TEXT &&
          get(data, 'fields.fieldType.value') !== DATE_TEXT
        ) {
          const isrequired = get(data, 'fields.isRequired.value')
            ? 'isRequired'
            : '';
          const rulesObject = {
            fieldName: get(data, 'fields.fieldName.value'),
            rules: [isrequired],
          };
          this.rules.push(rulesObject);
        }

        return data;
      });
      this.setState({
        formData: formData,
      });
    } catch (err) { }
  }

  addToPayload = (name, value) => {
    try {
      if ((name === FROM_LOCATION_TEXT || name === TO_LOCATION_TEXT) && value) {
        const regEx = /\(([^)]+)\)/;
        this.flightsPayload[name] =
          value.match(regEx) && value.match(regEx).length > 0
            ? value.match(regEx)[1]
            : '';
      } else {
        this.flightsPayload[name] = value;
      }
    } catch (error) {
      return;
    }
  };

  onFieldChange = event => {
    const { name, value } = event.target;
    // updating state with the updated values
    let { formData } = this.state;

    formData &&
      formData.map(data => {
        const { fieldName, selectedValue, endDateName, startDateName } =
          data && data.fields;
        if (fieldName && fieldName.value === name) {
          selectedValue.value = value;
          data.fields.showError = false;
          this.addToPayload(fieldName.value, value);
        } else if (
          (endDateName && endDateName.value === name) ||
          (startDateName && startDateName.value === name)
        ) {
          data.fields.showError = false;
          if (name === INBOUND_DATE) {
            data.fields.startDate.value = value;
            data.fields.endDate.value = '';
            this.addToPayload(name, moment(value).format('DD/MM/YYYY'));
          } else {
            data.fields.endDate.value = value;
            this.addToPayload(name, moment(value).format('DD/MM/YYYY'));
          }
        }
        return data;
      });
    this.setState({ formData });
  };

  autocompleteAPIForWego = (value, lang) => {
    try {
      const requestData = {
        url: `${this.props.appConfig &&
          this.props.appConfig.AUTO_COMPLETE_WEGO}/${value}.js?locale=${lang}`,
        method: 'Get',
      };

      fetchService(requestData).then(res => {
        if (get(res, 'data.r')) {
          let options = [];
          const apiData = res.data.r;
          apiData &&
            apiData.forEach(value => {
              if (value.fn) {
                options.push({ name: value.fn });
              }
            });
          this.setState({
            autoCompleteListItems: options,
          });
        }
      });
    } catch (err) {
      console.error('flights autocomplete API failure', err);
    }
  }

  autocompleteAPIForTravelPayout = (value, lang) => {
    try {
      const requestData = {
        url: `${this.props.appConfig &&
          this.props.appConfig.AUTO_COMPLETE_TRAVEL_PAYOUT}?term=${value}&locale=${lang}&types[]=country,city,airport`,
        method: 'Get',
      };

      fetchService(requestData).then(res => {
        if (get(res, 'data', '')) {
          let options = [];
          const apiData = res.data;
          apiData &&
            apiData.forEach(value => {
              if (value.country_name) {
                options.push({ name: `${value.name ? value.name : ''}${value.city_name ? `, ${value.city_name}` : ''}${value.country_name ? `, ${value.country_name}` : ''}${value.code ? ` (${value.code})` : ''}` });
              }
            });
          this.setState({
            autoCompleteListItems: options,
          });
        }
      });
    } catch (err) {
      console.error('flights autocomplete API failure', err);
    }
  }

  onInputChange = value => {
    let lang;
    if (
      this.language.includes('-') &&
      this.language.split('-').length > 0 &&
      this.language.split('-')[0] === 'ar'
    ) {
      lang = this.language.split('-')[0];
    } else {
      lang = this.language;
    }
    if (this.props.formType && this.props.formType.value === FORM_TYPE_TO_CHECK_FLIGHT) {
      this.autocompleteAPIForTravelPayout(value, lang);
    } else {
      this.autocompleteAPIForWego(value, lang);
    }
  };

  flightTabForm = classes => {
    const { formData } = this.state;
    const fields =
      formData &&
      formData.map((data, index) => {
        const Field = this.mapper[get(data, 'fields.fieldType.value')];
        if (get(data, 'fields.fieldType.value') === SUBMIT_TEXT) {
          this.redirectSitecoreURL = get(data, 'fields.submitActions[0].fields.redirectLink.value.href');
          return (
            <div
              key={index}
              className={clsx(classes.fullWidth, classes.button)}
            >
              <Field
                buttonType={'form'} //#TODO: This line is having warning on browser..need to look into it
                type={'submit'}
                size={'small'}
                hasBorder={false}
              >
                <Text field={data.fields.fieldLabel} />
              </Field>
            </div>
          );
        } else {
          if (get(data, 'fields.fieldType.value') === RADIOBUTTONLIST_TEXT) {
            // #TODO : Check if addToPayload can be removed
            this.addToPayload(
              get(data, 'fields.fieldName.value'),
              get(data, 'fields.selectedValue.value')
            );
            this.radioListValue = get(data, 'fields.selectedValue.value');
            return (
              <div key={index} className={classes.fullWidth}>
                <Field data={data.fields} onChange={this.onFieldChange} />
              </div>
            );
          }
          // Made 'To' field disabled since it contains only one option and doesn't allow user to open dropdown
          if (get(data, 'fields.fieldName.value') === TO_LOCATION_TEXT) {
            data.fields.isDisabled.value = true;
            this.addToPayload(
              get(data, 'fields.fieldName.value'),
              get(data, 'fields.selectedValue.value')
            );
            return (
              <Field
                key={index}
                data={data.fields}
                onChange={this.onFieldChange}
                className={classes.toDropdown}
              />
            );
          }
          if (get(data, 'fields.fieldType.value') === DATE_TEXT) {
            let monthsShown = 1;
            this.addToPayload(
              get(data, 'fields.startDateName.value'),
              get(data, 'fields.startDate.value')
            );
            this.addToPayload(
              get(data, 'fields.endDateName.value'),
              get(data, 'fields.endDate.value')
            );
            // #TODO : Check if RETURN_LABEL_TEXT (i18n) to be passed from sitecore
            if (this.radioListValue === RETURN_LABEL_TEXT) {
              monthsShown = 2;
              data.fields.fieldLabel.value = get(
                data,
                'fields.dateReturnLabel'
              );
            } else {
              data.fields.fieldLabel.value = get(
                data,
                'fields.secondaryFieldLabel.value'
              );
            }
            return (
              <Field
                key={index}
                data={data.fields}
                shouldSetMinDate={true}
                onChange={this.onFieldChange}
                monthsShown={monthsShown}
              />
            );
          } else {
            this.addToPayload(
              get(data, 'fields.fieldName.value'),
              get(data, 'fields.selectedValue.value')
            );
            return (
              <Field
                key={index}
                data={data.fields}
                onChange={this.onFieldChange}
                inputChange={this.onInputChange}
                listItems={this.state.autoCompleteListItems}
                variant={'body3'}
                disableClearable={true}
              />
            );
          }
        }
      });
    return <div className={classes.formWrapper}>{fields}</div>;
  };

  addAnalyticsData = (from_location, to_location, trip_type, cabin_class) => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.findDealClicks'),
      ...{
        action: `${get(analyticsData, 'dataLinksText.findDeals')}-${get(
          analyticsData,
          'dataLinksText.flightFormText'
        )}`,
        label: createDynamicLabels([
          this.props.pageName,
          this.props.componentName,
          `${from_location}_${to_location}_${trip_type}_${cabin_class}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  redirectToWego = () => {
    let {
      Inbound_date,
      Outbound_date,
      cabin_class,
      from_location,
      num_adults,
      num_children,
      to_location,
      trip_type,
    } = this.flightsPayload;
    this.addAnalyticsData(from_location, to_location, trip_type, cabin_class);
    Inbound_date = moment(Inbound_date).format('YYYY-MM-DD');
    Outbound_date = moment(Outbound_date).format('YYYY-MM-DD');
    let searchURL = this.redirectSitecoreURL;
    if (
      this.language.includes('-') &&
      this.language.split('-').length > 0 &&
      (this.language.split('-')[0] === 'ar' ||
        this.language.split('-')[0] === 'en')
    ) {
      let language = this.language.split('-')[0];
      searchURL = replaceKeysLabelText(
        { value: this.redirectSitecoreURL },
        [language.toLowerCase()]
      );
    } else if (this.language.toLowerCase() === LANGUAGE_CODE.HEBREW) {
      let language = LANGUAGE_CODE.DEFAULT;
      searchURL = replaceKeysLabelText(
        { value: this.redirectSitecoreURL },
        [language.toLowerCase()]
      );
    } else {
      searchURL = replaceKeysLabelText(
        { value: this.redirectSitecoreURL },
        [this.language.toLowerCase()]
      );
    }
    let url = `${searchURL.value
      }${from_location}/${to_location}/${Inbound_date}/${trip_type === 'One-way' ? 'oneway' : Outbound_date
      }/${cabin_class.toLowerCase()}/${num_adults}/${num_children}/`;
    window.open(url);
  }

  redirectToTravelPayout = () => {
    let {
      Inbound_date,
      Outbound_date,
      from_location,
      to_location,
      trip_type,
      num_adults,
      num_children,
      cabin_class,
    } = this.flightsPayload;
    this.addAnalyticsData(from_location, to_location, '', '');
    Inbound_date = moment(Inbound_date).format('YYYY-MM-DD');
    Outbound_date = moment(Outbound_date).format('YYYY-MM-DD');
    let searchURL = this.redirectSitecoreURL;
    const currency = getDictionaryText('currency');
    let url = `${searchURL
      }?origin_iata=${from_location
      }&destination_iata=${to_location}&depart_date=${Inbound_date}${Outbound_date ? `&return_date=${Outbound_date}` : ''}&one_way=${trip_type === 'One-way' ? true : false
      }&with_request=true&adults=${num_adults}&children=${num_children}&infants=0&trip_class=${cabin_class}${currency ? `&currency=${currency}` : ''}&locale=${this.language}&one_way=false&ct_guests=1+passenger&ct_rooms=1`;
    window.open(url);
  }

  onFormSubmit = e => {
    e.preventDefault();
    const error = this.props.validateForm(this.rules, this.flightsPayload);
    if (!isEmpty(error)) {
      let formData = this.state.formData;
      formData.map(data => {
        if (
          error[
          get(data, 'fields.fieldName') && get(data, 'fields.fieldName.value')
          ]
        ) {
          data.fields.showError = true;
        }
        return data;
      });

      this.setState({ formData });
    } else {
      if (this.props.formType && this.props.formType.value === FORM_TYPE_TO_CHECK_FLIGHT) {
        this.redirectToTravelPayout();
      } else {
        this.redirectToWego();
      }
    }
  };

  render() {
    if (get(this.state, 'formData.length') === 0) {
      return '';
    }
    const { classes } = this.props;

    return (
      <Form onSubmit={this.onFormSubmit}>{this.flightTabForm(classes)}</Form>
    );
  }
}

export default withSitecoreContext()(FlightsForm);
